// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResults_searchContainer__BMzye {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  font-family: 'Arial', sans-serif;
}

/* Loading State */
.SearchResults_loadingState__jl3vu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.SearchResults_spinner__y7rSB {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #1a5f3f;
  border-radius: 50%;
  animation: SearchResults_spin__z1QaI 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes SearchResults_spin__z1QaI {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error State */
.SearchResults_errorState__p7meW {
  background: #fee2e2;
  border: 2px solid #fca5a5;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  color: #dc2626;
  margin: 40px 0;
}

.SearchResults_retryButton__Ba3Dp {
  background: #1a5f3f;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 20px;
  transition: background 0.3s ease;
}

.SearchResults_retryButton__Ba3Dp:hover {
  background: #0f4229;
}

/* Search Header */
.SearchResults_searchHeader__GGnxq {
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
}

.SearchResults_searchTitle__-yqUK {
  font-size: 24px;
  color: #1a202c;
  margin: 0 0 10px 0;
  font-weight: 700;
}

.SearchResults_searchTerm__QebYJ {
  color: #1a5f3f;
  background: rgba(26, 95, 63, 0.1);
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 600;
}

.SearchResults_resultsCount__GIRnG {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

/* No Results */
.SearchResults_noResults__3yMs6 {
  text-align: center;
  padding: 80px 20px;
  color: #64748b;
}

.SearchResults_noResultsIcon__256rM {
  font-size: 64px;
  margin-bottom: 20px;
}

.SearchResults_noResults__3yMs6 h3 {
  font-size: 20px;
  color: #374151;
  margin: 0 0 12px 0;
}

.SearchResults_noResults__3yMs6 p {
  font-size: 16px;
  margin: 0;
}

/* Category Sections */
.SearchResults_categorySections__jUYJN {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.SearchResults_categorySection__9aUMQ {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
}

.SearchResults_categoryHeader__LG1-6 {
  margin-bottom: 30px;
}

.SearchResults_categoryTitle__Dv8tZ {
  display: flex;
  align-items: center;
  gap: 12px;
}

.SearchResults_categoryIcon__Yp6eE {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 6px;
}

.SearchResults_categoryTitle__Dv8tZ h2 {
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}

.SearchResults_categoryCount__TvNoo {
  background: rgba(0, 0, 0, 0.1);
  color: #64748b;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

/* Posts Grid */
.SearchResults_postsGrid__TqL-D {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

/* Post Cards */
.SearchResults_postCard__yndea {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.SearchResults_postCard__yndea:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-color: var(--category-color);
}

.SearchResults_postImageContainer__dAlIV {
  position: relative;
  width: 100%;
  height: 160px;
  overflow: hidden;
}

.SearchResults_postImage__MS33\\+ {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.SearchResults_postCard__yndea:hover .SearchResults_postImage__MS33\\+ {
  transform: scale(1.05);
}

.SearchResults_postOverlay__oSfq- {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  padding: 6px;
  backdrop-filter: blur(4px);
}

.SearchResults_postIcon__MT3Ht {
  width: 20px;
  height: 20px;
  object-fit: cover;
}

/* Post Content */
.SearchResults_postContent__owObU {
  padding: 20px;
}

.SearchResults_postTitle__YbrRU {
  font-size: 16px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 12px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.SearchResults_postMeta__4UsAs {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 12px;
  color: #64748b;
}

.SearchResults_postAuthor__zR-et {
  font-weight: 600;
}

.SearchResults_metaSeparator__BeBxw {
  color: #cbd5e1;
}

.SearchResults_postDate__59XPT {
  font-weight: 500;
}

.SearchResults_postCategory__CmgQG {
  display: flex;
  justify-content: flex-end;
}

.SearchResults_categoryBadge__BlErP {
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}

/* Responsive Design */
@media (max-width: 768px) {
  .SearchResults_searchContainer__BMzye {
    padding: 15px;
  }

  .SearchResults_categorySection__9aUMQ {
    padding: 20px;
  }

  .SearchResults_postsGrid__TqL-D {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
  }

  .SearchResults_searchTitle__-yqUK {
    font-size: 20px;
  }

  .SearchResults_categoryTitle__Dv8tZ h2 {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .SearchResults_postsGrid__TqL-D {
    grid-template-columns: 1fr;
  }

  .SearchResults_searchTitle__-yqUK {
    font-size: 18px;
  }

  .SearchResults_categoryTitle__Dv8tZ {
    flex-wrap: wrap;
    gap: 8px;
  }

  .SearchResults_postImageContainer__dAlIV {
    height: 140px;
  }

  .SearchResults_postContent__owObU {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Search bars/SearchResults.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,uDAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".searchContainer {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  direction: rtl;\r\n  font-family: 'Arial', sans-serif;\r\n}\r\n\r\n/* Loading State */\r\n.loadingState {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px 20px;\r\n  text-align: center;\r\n}\r\n\r\n.spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid #f3f3f3;\r\n  border-top: 4px solid #1a5f3f;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n/* Error State */\r\n.errorState {\r\n  background: #fee2e2;\r\n  border: 2px solid #fca5a5;\r\n  border-radius: 12px;\r\n  padding: 40px;\r\n  text-align: center;\r\n  color: #dc2626;\r\n  margin: 40px 0;\r\n}\r\n\r\n.retryButton {\r\n  background: #1a5f3f;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 12px 24px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  margin-top: 20px;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.retryButton:hover {\r\n  background: #0f4229;\r\n}\r\n\r\n/* Search Header */\r\n.searchHeader {\r\n  margin-bottom: 40px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 2px solid #f0f0f0;\r\n}\r\n\r\n.searchTitle {\r\n  font-size: 24px;\r\n  color: #1a202c;\r\n  margin: 0 0 10px 0;\r\n  font-weight: 700;\r\n}\r\n\r\n.searchTerm {\r\n  color: #1a5f3f;\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 4px 12px;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n}\r\n\r\n.resultsCount {\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* No Results */\r\n.noResults {\r\n  text-align: center;\r\n  padding: 80px 20px;\r\n  color: #64748b;\r\n}\r\n\r\n.noResultsIcon {\r\n  font-size: 64px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.noResults h3 {\r\n  font-size: 20px;\r\n  color: #374151;\r\n  margin: 0 0 12px 0;\r\n}\r\n\r\n.noResults p {\r\n  font-size: 16px;\r\n  margin: 0;\r\n}\r\n\r\n/* Category Sections */\r\n.categorySections {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 50px;\r\n}\r\n\r\n.categorySection {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 30px;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n.categoryHeader {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.categoryTitle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.categoryIcon {\r\n  width: 32px;\r\n  height: 32px;\r\n  object-fit: cover;\r\n  border-radius: 6px;\r\n}\r\n\r\n.categoryTitle h2 {\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n\r\n.categoryCount {\r\n  background: rgba(0, 0, 0, 0.1);\r\n  color: #64748b;\r\n  padding: 4px 8px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Posts Grid */\r\n.postsGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 20px;\r\n}\r\n\r\n/* Post Cards */\r\n.postCard {\r\n  background: white;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.postCard:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\r\n  border-color: var(--category-color);\r\n}\r\n\r\n.postImageContainer {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 160px;\r\n  overflow: hidden;\r\n}\r\n\r\n.postImage {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.postCard:hover .postImage {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.postOverlay {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  border-radius: 8px;\r\n  padding: 6px;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.postIcon {\r\n  width: 20px;\r\n  height: 20px;\r\n  object-fit: cover;\r\n}\r\n\r\n/* Post Content */\r\n.postContent {\r\n  padding: 20px;\r\n}\r\n\r\n.postTitle {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #1a202c;\r\n  margin: 0 0 12px 0;\r\n  line-height: 1.4;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.postMeta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n  font-size: 12px;\r\n  color: #64748b;\r\n}\r\n\r\n.postAuthor {\r\n  font-weight: 600;\r\n}\r\n\r\n.metaSeparator {\r\n  color: #cbd5e1;\r\n}\r\n\r\n.postDate {\r\n  font-weight: 500;\r\n}\r\n\r\n.postCategory {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.categoryBadge {\r\n  color: white;\r\n  padding: 4px 12px;\r\n  border-radius: 16px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .searchContainer {\r\n    padding: 15px;\r\n  }\r\n\r\n  .categorySection {\r\n    padding: 20px;\r\n  }\r\n\r\n  .postsGrid {\r\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\r\n    gap: 16px;\r\n  }\r\n\r\n  .searchTitle {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .categoryTitle h2 {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .postsGrid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .searchTitle {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .categoryTitle {\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n  }\r\n\r\n  .postImageContainer {\r\n    height: 140px;\r\n  }\r\n\r\n  .postContent {\r\n    padding: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchContainer": `SearchResults_searchContainer__BMzye`,
	"loadingState": `SearchResults_loadingState__jl3vu`,
	"spinner": `SearchResults_spinner__y7rSB`,
	"spin": `SearchResults_spin__z1QaI`,
	"errorState": `SearchResults_errorState__p7meW`,
	"retryButton": `SearchResults_retryButton__Ba3Dp`,
	"searchHeader": `SearchResults_searchHeader__GGnxq`,
	"searchTitle": `SearchResults_searchTitle__-yqUK`,
	"searchTerm": `SearchResults_searchTerm__QebYJ`,
	"resultsCount": `SearchResults_resultsCount__GIRnG`,
	"noResults": `SearchResults_noResults__3yMs6`,
	"noResultsIcon": `SearchResults_noResultsIcon__256rM`,
	"categorySections": `SearchResults_categorySections__jUYJN`,
	"categorySection": `SearchResults_categorySection__9aUMQ`,
	"categoryHeader": `SearchResults_categoryHeader__LG1-6`,
	"categoryTitle": `SearchResults_categoryTitle__Dv8tZ`,
	"categoryIcon": `SearchResults_categoryIcon__Yp6eE`,
	"categoryCount": `SearchResults_categoryCount__TvNoo`,
	"postsGrid": `SearchResults_postsGrid__TqL-D`,
	"postCard": `SearchResults_postCard__yndea`,
	"postImageContainer": `SearchResults_postImageContainer__dAlIV`,
	"postImage": `SearchResults_postImage__MS33+`,
	"postOverlay": `SearchResults_postOverlay__oSfq-`,
	"postIcon": `SearchResults_postIcon__MT3Ht`,
	"postContent": `SearchResults_postContent__owObU`,
	"postTitle": `SearchResults_postTitle__YbrRU`,
	"postMeta": `SearchResults_postMeta__4UsAs`,
	"postAuthor": `SearchResults_postAuthor__zR-et`,
	"metaSeparator": `SearchResults_metaSeparator__BeBxw`,
	"postDate": `SearchResults_postDate__59XPT`,
	"postCategory": `SearchResults_postCategory__CmgQG`,
	"categoryBadge": `SearchResults_categoryBadge__BlErP`
};
export default ___CSS_LOADER_EXPORT___;
